import React, { Suspense } from 'react';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import '@gsa/afp-component-library/dist/css/index.css';
import { Spinner, DefaultLayout } from '@gsa/afp-component-library';
import {
  AppProvider,
  FeatureProvider,
  PublicRoute,
  Unauthorized,
} from '@gsa/afp-shared-ui-utils';
import LogoutPage from './pages/auth/logout';
import Layout from './utilities/Layout';
import { NotificationProvider } from './utilities/notification/notification-provider';
import GET_ENABLED_CATALOG_FEATURES from './utilities/feature-toggle/enabled-features-query';
import dataStore, { sharedGatewayClient } from './services/data-store';
import AppRoutes from './components/RouterComponent/AppRoutes';
import './App.scss';
import './datadog-monitoring';
import FedVehicleStandardsPublic from './pages/fvs-public';
import GlobalErrorMessages from './pages/error/global-error-messages';

function App() {
  const publicPageMenuItems = [
    {
      title: 'Home',
      href: `${window.AFP_CONFIG.appURLs.home}`,
      isHidden: false,
      permission: null,
      childNavigationItems: [],
    },
    {
      title: 'Help',
      href: `${window.AFP_CONFIG.appURLs.home}/help`,
      isHidden: false,
      permission: null,
      childNavigationItems: [],
    },
  ];

  return (
    <Router>
      <Routes>
        <Route
          path="/catalog/*"
          element={
            <PublicRoute title="Catalog">
              <RecoilRoot>
                <ApolloProvider client={dataStore}>
                  <AppProvider>
                    <FeatureProvider
                      featureQuery={GET_ENABLED_CATALOG_FEATURES}
                    >
                      <NotificationProvider>
                        <Layout>
                          <Suspense
                            fallback={
                              <Spinner
                                data-testid="lazy-load-spinner"
                                size="small"
                              />
                            }
                          >
                            <AppRoutes />
                          </Suspense>
                        </Layout>
                      </NotificationProvider>
                    </FeatureProvider>
                  </AppProvider>
                </ApolloProvider>
              </RecoilRoot>
            </PublicRoute>
          }
        />
        {/* Public routes - Fed Vehicle Standards */}
        <Route
          path="/public/*"
          element={
            <PublicRoute title="Catalog">
              <RecoilRoot>
                <ApolloProvider client={sharedGatewayClient}>
                  <DefaultLayout
                    currentUser={undefined}
                    menu={publicPageMenuItems}
                  >
                    <GlobalErrorMessages />
                    <FedVehicleStandardsPublic />
                  </DefaultLayout>
                </ApolloProvider>
              </RecoilRoot>
            </PublicRoute>
          }
        />
        <Route
          path="/unauthorized"
          element={
            <PublicRoute title="Access Denied">
              <DefaultLayout currentUser={undefined} menu={publicPageMenuItems}>
                <Unauthorized />
              </DefaultLayout>
            </PublicRoute>
          }
        />
        {/* Logout */}
        <Route path="/logout" element={<LogoutPage />} />
      </Routes>
    </Router>
  );
}

export default App;
